// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"289":"6be5a334","429":"bc74b57f"}[chunkId] + ".chunk.css";
};